export default {
  setItems: (state, data) => {
    state.items.splice(0)

    // eslint-disable-next-line array-callback-return
    data.map(x => {
      state.items.push({
        id: x.id,
        email: x.email,
        name: x.name,
        profile: x.profile,
        company: x.company,
        phone: x.phone,
        url: x.url,
      })
    })
  },
}
